var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "course" },
    [
      _vm.course
        ? [
            _c("div", { staticClass: "course-info" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-breadcrumbs", {
                          staticClass: "p-0",
                          attrs: { items: _vm.breadcrumbs },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { class: { "pc-width": !_vm.isMobile } }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("v-col", { staticClass: "mb-9", attrs: { lg: "6" } }, [
                      _c("h2", { staticClass: "text-h2 mb-6" }, [
                        _vm._v(_vm._s(_vm.course.name)),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "my-3",
                        domProps: { innerHTML: _vm._s(_vm.course.description) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { staticClass: "pe-8", attrs: { lg: "6" } },
                      [
                        _c("v-img", { attrs: { src: _vm.course.image.url } }),
                        _vm._v(" "),
                        _c("CourseButton", {
                          staticClass: "mt-3",
                          attrs: { course: _vm.course, user: _vm.user },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { class: { "pc-width": !_vm.isMobile } }, [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm.course.chapters.length > 0
                        ? _vm._l(_vm.course.chapters, function (chapter) {
                            return _c(
                              "div",
                              { key: chapter.id, staticClass: "d-flex" },
                              [
                                _c("v-col", { staticClass: "bg-white" }, [
                                  _c("div", { staticClass: "text-h4 mb-4" }, [
                                    _vm._v(_vm._s(chapter.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-4" }, [
                                    _vm._v(_vm._s(chapter.description)),
                                  ]),
                                  _vm._v(" "),
                                  chapter.lessons.length > 0
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          chapter.lessons,
                                          function (lesson, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "mb-3",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "me-1",
                                                    attrs: {
                                                      small: "",
                                                      color: "pink",
                                                    },
                                                  },
                                                  [_vm._v("check_circle")]
                                                ),
                                                _vm._v(
                                                  "Lesson " +
                                                    _vm._s(index + 1) +
                                                    ": " +
                                                    _vm._s(lesson.name) +
                                                    "\n                  "
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                              1
                            )
                          })
                        : [
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _c("v-col", { staticClass: "bg-white" }, [
                                  _vm.course.lessons.length > 0
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.course.lessons,
                                          function (lesson, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "mb-3",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "me-1",
                                                    attrs: {
                                                      small: "",
                                                      color: "pink",
                                                    },
                                                  },
                                                  [_vm._v("check_circle")]
                                                ),
                                                _vm._v(
                                                  "Lesson " +
                                                    _vm._s(index + 1) +
                                                    ": " +
                                                    _vm._s(lesson.name) +
                                                    "\n                  "
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }